<template>
  <div>
    <v-container>
      <v-row>
        <v-col cols="12">
          <v-card class="card--shadow">
            <pa-list :pas="pas" />
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import PaList from "@/components/pa/PaList";
import { mapState } from "vuex";

export default {
  components: {
    PaList,
  },
  computed: {
    ...mapState("Pa", ["pas"]),
  },
  created() {
    this.$store.dispatch("Pa/getPAs");
  },
};
</script>

<style scoped>
.card--shadow {
  box-shadow: var(--primary-box-shadow) !important;
}
</style>
